// TODO: 2021-07-29 - Removed text "La gara vedrà di fronte i due allenatori <b><% coachTeamHome %></b> e <b><% coachTeamAway %></b>"
// Text will be added again when BE data fixes missing coaches issue
export const articleTemplatePreview = `
<h1 class='ftbl__article-builder-content--h1'><% teamHome %>–<% teamAway %>: come seguire la partita.</h1>
Segui live la partita di <% competition %>  <% teamHomeWithLink %>-<% teamAwayWithLink %> su <b>skysport.it</b>.<br> 
La gara vedrà di fronte i due allenatori <b><% coachTeamHome %></b> e <b><% coachTeamAway %></b>.<br>
Le probabili formazioni, tutte le news per arrivare preparato al meglio al match e tutti gli aggiornamenti 
in diretta live dell’incontro che si giocherà <% venueTextPrefix %> <b> <% venue %> <% dayMonthYear %></b> alle ore <b><% hours %></b>.
<br>
<hr class='ftbl__article-builder-content--hr' />
In attesa della partita puoi scoprire il mondo dedicato a <% teamHomeWithLink %> e <% teamAwayWithLink %> e su <b>skysport.it.</b><br>
<br>
Vuoi rivedere tutti i numeri o leggere le ultime news di <% competition %>?<br>
- <% homeNewsCompetitionLink %><br>
- <% calendarLink %><br>
- <% rankingLink %><br>
- <% resultsLink %><br>
<h2 class='ftbl__article-builder-content--h2'>Riepilogo partita: date e orari.</h2>
Partita: <% teamHomeWithLink %>–<% teamAwayWithLink %><br>
Campionato: <% competition %><br>
Data: <b><% dayMonthYear %></b><br>
Orario calcio d’inizio: <b><% hours %></b><br>
<% venueRowPrefix %> <b><% venue %></b>`;

export const venueRowPrefix = 'Stadio:';

export const venueTextPrefix = 'allo stadio';
interface ITextElm {
  readonly text: string;
}
interface ITextAndLink {
  readonly text: string;
  readonly link?: string;
}

export interface IArticleTemplatePreviewElements {
  readonly teamHome: ITextElm;
  readonly teamAway: ITextElm;
  readonly teamHomeWithLink: ITextAndLink;
  readonly teamAwayWithLink: ITextAndLink;
  readonly competition: ITextAndLink;
  readonly dayMonthYear: ITextElm;
  readonly hours: ITextElm;
  readonly coachTeamHome: ITextElm;
  readonly coachTeamAway: ITextElm;
  readonly homeNewsCompetitionLink: ITextAndLink;
  readonly calendarLink: ITextAndLink;
  readonly rankingLink: ITextAndLink;
  readonly resultsLink: ITextAndLink;
  readonly venue: ITextElm;
  readonly venueRowPrefix: ITextElm;
  readonly venueTextPrefix: ITextElm;
}
